<template>
  <div
    v-if="errorMessage"
    class="rounded-xl bg-red-100 px-4 py-2 text-sm text-red-500"
  >
    {{ errorMessage }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { last } from 'lodash-es';

  const props = defineProps<{
    text: string | Array<string>;
  }>();

  const errorMessage = computed(() =>
    Array.isArray(props.text) ? last(props.text) : props.text,
  );
</script>
